import React, { Component } from "react";
import axios from "axios";
import { Config } from "../../../data/config";
import { connect } from "react-redux";
import { displayError, resetError } from "../../../store/actions/error";
import { setForm } from "../../../store/actions/form";
import ErrorMessage from "../../error-message/ErrorMessage";
import { Loader } from "../../Loader/Loader";
import {
  AVAILABLE_NOT_PREWIRED,
  AVAILABLE_PREWIRED
} from "../../../data/status";
import { googleTracking } from "../../../util";
import ChangeSummary from "fs-change-summary";
import moment from "moment";
import LogRocket from 'logrocket';
import {shouldProcessAsUnscheduledLead} from '../../../util';

class Step5 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      isLoading: false,
      heardAboutUs: null
    };

    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);
    this.submit = this.submit.bind(this);
    this.setDeliveryDate = this.setDeliveryDate.bind(this);
  }

  componentDidMount() {
    const { status } = this.props.connection;

    this.setState({
      visible: true
    });
    if (status === AVAILABLE_PREWIRED) {
      googleTracking({ 'event': 'virtualPageview', 'pageview': '/prewired/step6/review-your-order' });
    }
    else if (status === AVAILABLE_NOT_PREWIRED) {
      googleTracking({ 'event': 'virtualPageview', 'pageview': '/not-prewired/step6/review-your-order' });
    }
    this.props.resetError();

    this.getShiponDate();

    this.setState({
      openToDate: this.getFirstDeliveryDate()
    });

  }

  isWeekday(date) {
    const day = date.day();
    return day !== 0 && day !== 6;
  };

  getShiponDate() {
    this.setOrderText();
  }

  getFirstDeliveryDate() {
    const activationTime = moment().format('LT');
    const beginningTime = moment(activationTime, 'h:mma');
    const endTime = moment('5:00pm', 'h:mma');
    let processingDays = 0;

    if (!beginningTime.isBefore(endTime)) {
      processingDays = 4;
    }
    else {
      processingDays = 3;
    }
    let firstDeliveryDate = this.getFirstBusinessDay();
    let daysAdded = 0;
    while (daysAdded !== processingDays) {
      firstDeliveryDate.add('1', 'days');
      if (this.isWeekday(firstDeliveryDate)) {
        daysAdded++;
      }
    }
    return firstDeliveryDate;
  }

  getFirstBusinessDay() {
    let firstBusinessDay = moment();
    while (!this.isWeekday(firstBusinessDay)) {
      firstBusinessDay.add('1', 'days');
    }
    return firstBusinessDay;
  }

  setOrderText() {
    axios
      .get(`${Config.frontApiUrl}/sources`)
      .then(res => {
        const data = res.data.data || [];
        const heardAboutUsOptions = data.map(option => {
          option.value = option.id;
          option.text = option.name;

          return option;
        });

        heardAboutUsOptions.sort((a, b) => {
          const textA = a.text.toUpperCase();
          const textB = b.text.toUpperCase();

          let comparison = 0;
          if (textA > textB) {
            comparison = 1;
          } else if (textA < textB) {
            comparison = -1;
          }
          return comparison;
        });

        heardAboutUsOptions.unshift({ value: 0, text: 'How did you hear about us?'});

        this.setState({
          heardAboutUs: heardAboutUsOptions
        });
      })
      .catch(error => { });
    this.props.resetError();
  }

  transitionBack() {
    const { changeStep, connection } = this.props;

    this.setState({
      animation: "fade left",
      visible: false
    });
    if (connection.status === AVAILABLE_PREWIRED) {
      setTimeout(() => {
        changeStep(4, "fade right");
      }, 400);
    } else if (connection.status === AVAILABLE_NOT_PREWIRED) {
      setTimeout(() => {
        changeStep(3, "fade right");
      }, 400);
    }
  }

  transitionNext() {
    const { changeStep, form, connection } = this.props;

    this.setState({
      animation: "fade right",
      visible: false
    });

    if (connection.status === AVAILABLE_PREWIRED) {
      setTimeout(() => {
        changeStep(6, "fade left");
      }, 400);
    } else if (connection.status === AVAILABLE_NOT_PREWIRED) {
      changeStep(form.otherTimeSlot === true ? 9 : 8, "fade left");
    }
  }

  getFormDataForAvailableNotPrewired() {
    const { form, connection } = this.props;
    const data = {};
    data.first_name = form.first_name;
    data.last_name = form.last_name;
    data.email = form.email;
    data.bid = connection.bid;
    data.unit = connection.unitNo;
    data.phone = form.phone;
    if (form.wifiRouter > 0) {
      data.hardware = form.wifiRouter;
    }
    data.services = [form.homePhone, form.unlimitedInternet]
      .filter(Boolean)
      .join(",");

    if (form.promotion) {
      data.promo_id = form.promotion;
    }

    if (form.timeslot) {
      if (form.timeslotType === "custom") {
        data.custom_timeslot_id = form.timeslot;
      } else {
        data.promo_timeslot_id = form.timeslot;
      }
    }
    return data;
  }

  getFormDataForAvailablePrewired() {
    const { form, connection } = this.props;
    const data = {};
    data.first_name = form.first_name;
    data.last_name = form.last_name;
    data.email = form.email;
    data.bid = connection.bid;
    data.unit = connection.unitNo;
    data.phone = form.phone;
    if (form.wifiRouter > 0) {
      data.hardware = form.wifiRouter;
    }
    data.services = [form.homePhone, form.unlimitedInternet]
      .filter(Boolean)
      .join(",");

    if ( ! shouldProcessAsUnscheduledLead(form.unlimitedInternetObj.code)) {
      data.activation_date = form.activationDate;
    }
    
    data.delivery_date = form.deliveryDate;
    data.heard_about_us = form.heardAboutUs;
    if (form.promotion) {
      data.promo_id = form.promotion;
    }

    return data;
  }

  getFormData() {
    const { connection } = this.props;
    let data = {};
    if (connection.status === AVAILABLE_NOT_PREWIRED) {
      data = this.getFormDataForAvailableNotPrewired();
    } else if (connection.status === AVAILABLE_PREWIRED) {
      data = this.getFormDataForAvailablePrewired();
    }
    return data;
  }

  afterResponse(response) {
    const { connection } = this.props;
    if (connection.status === AVAILABLE_PREWIRED) {
      const jobId = response.account_result.job_id || null;
      if (jobId) {
        this.props.setForm({ job_id: jobId });
      }
    } else if (connection.status === AVAILABLE_NOT_PREWIRED) {
      const leadId = response.lead_result.lead_id || null;
      const message = response.lead_result.message || null;

      if (leadId) {
        this.props.setForm({ lead_id: leadId, message: message });
      }
    }
  }

  submit() {
    const { displayError } = this.props;
    this.setState({
      isLoading: true
    });

    axios
      .post(
        `${Config.frontApiUrl}/onboarding/account/create`,
        this.getFormData()
      )
      .then(response => {
        this.addToLogRocket();
        this.afterResponse(response.data);
        this.transitionNext();
      })
      .catch(error => {
        this.setState({
          isLoading: false
        });
        displayError();
      });
  }

  addToLogRocket() {
    const form = { ...this.getFormData() };
    form.name = `${form.first_name} ${form.last_name}`;
    LogRocket.identify(form.email, form);
  }


  setDeliveryDate(date) {
    const { setForm } = this.props;
    setForm({ deliveryDate: date });
  }

  setHeardAboutUs(id) {
    const { setForm } = this.props;
    setForm({ heardAboutUs: id });
  }

  render() {
    const {
      connection,
      unlimitedInternetObj,
      wifiRouterObj,
      homePhoneObj,
      promotionObj,
      shipping,
      activationDate,
      taxes
    } = this.props;
    const { isLoading, heardAboutUs } = this.state;
    return (
      <div>
        <div className="back--icon" onClick={this.transitionBack} />
        <ChangeSummary
          taxes={taxes.percent}
          connectionStatus={connection.status}
          unlimitedInternetData={unlimitedInternetObj}
          promotionData={promotionObj}
          homePhoneData={homePhoneObj}
          wifiRouterData={wifiRouterObj}
          shipping={shipping}
          errorMessageComponent={<ErrorMessage />}
          loaderComponent={isLoading && <Loader />}
          activationDate={activationDate}
          setDeliveryDate={this.setDeliveryDate}
          submit={this.submit}
          reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          options={heardAboutUs}
          setHeardAboutUs={this.setHeardAboutUs.bind(this)}
          heardAboutUsPlaceholder="How did you hear about us?"
          securityConcierge={connection.security_concierge}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: state.form,
    connection: state.connection,
    wifiRouter: state.form.wifiRouter,
    unlimitedInternetObj: state.form.unlimitedInternetObj,
    wifiRouterObj: state.form.wifiRouterObj,
    homePhoneObj: state.form.homePhoneObj,
    promotionObj: state.form.promotionObj,
    shipping: state.service.shipping,
    homePhone: state.form.homePhone,
    promotion: state.form.promotion,
    activationDate: state.form.activationDate,
    taxes: state.taxes
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetError: () => dispatch(resetError()),
    displayError: () => dispatch(displayError()),
    setForm: data => dispatch(setForm(data)),
    setActivationDate: data => dispatch(setForm(data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step5);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-available/Step5.js